import { Tabs, TabsList, TabsTrigger } from "@spz/ui/components/tabs";
import { useState } from "react";
import { useResultDetailActivityTabViewModel } from "../../hooks/use-result-detail-activity-tabs-view-model";

type ResultDetailActivityTabsProps = {
  controlId: string;
  companyId: string;
  controlResultId: string;
};

const ResultDetailActivityTabs = ({
  controlId,
  companyId,
  controlResultId,
}: ResultDetailActivityTabsProps) => {
  const { tabs } = useResultDetailActivityTabViewModel({
    controlId,
    companyId,
    controlResultId,
  });
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  const activeContent =
    tabs.find((tab) => tab.value === activeTab)?.component || null;

  return (
    <div className="w-full bg-white rounded-lg shadow text-left text-sm">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              data-testid={tab.testId}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <div className="mt-4 flex flex-col">{activeContent}</div>
      </Tabs>
    </div>
  );
};

export default ResultDetailActivityTabs;
